import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SPECIAL_OFFER_ROUTES } from 'src/app/core/constants/routes-constants';

@Component({
  selector: 'special-offers',
  templateUrl: './special-offer-requested.component.html',
  styleUrls: ['./special-offer-requested.component.scss'],
  standalone: false,
})
export class SpecialOfferRequestedComponent {
  constructor(private readonly _router: Router) {}

  redirectToSpecialOffersList() {
    this._router.navigate([SPECIAL_OFFER_ROUTES.SPECIAL_OFFERS]);
  }
}
